<template>
  <v-container>
    <!-- Título -->
    <h2 class="text-h5 mb-6">Biblioteca de Vídeos</h2>

    <!-- Filtros -->
    <v-row class="mb-4" align="center">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="search"
          label="Buscar vídeos..."
          prepend-inner-icon="mdi-magnify"
          clearable
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          v-model="filterType"
          :items="types"
          label="Filtrar por tipo"
          clearable
        />
      </v-col>
    </v-row>

    <!-- Grid de vídeos -->
    <v-row>
      <v-col
        v-for="video in paginatedVideos"
        :key="video.id"
        cols="12" sm="6" md="4"
      >
        <v-card class="rounded-xl">
          <v-responsive aspect-ratio="16/9">
            <iframe
              v-if="video.video_url_embed"
              :src="video.video_url_embed"
              frameborder="0"
              allowfullscreen
              class="w-full h-full"
            ></iframe>
          </v-responsive>
          <v-card-title class="text-subtitle-1 font-weight-bold">
            {{ video.title }}
          </v-card-title>
          <v-card-text class="text-body-2">
            {{ video.description }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Paginação -->
    <v-row justify="center" class="mt-6">
      <v-pagination
        v-model="page"
        :length="totalPages"
        total-visible="7"
        rounded="circle"
      />
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import api from "@/services/api";
import { useLoadingOverlay } from "@/store/loadingOverlay";

const videos = ref([]);
const search = ref("");
const filterType = ref(null);
const page = ref(1);
const perPage = 6;
const loadingOverlay = useLoadingOverlay();

const types = [
  { title: "Internos", value: "internal" },
  { title: "Externos", value: "external" },
];

const loadVideos = async () => {
  loadingOverlay.startLoading();
  try {
    const response = await api.get("/videos",{
      params: {
        type: 'internal', is_active: 1
      }
    });
    videos.value = response.data.data;
  } catch (error) {
    console.error("Erro ao carregar vídeos:", error);
    toastStore.showToast({
      message:
        error?.response?.data?.error ||
        "Ocorreu um erro ao carregar a lista de vídeos.",
      color: "error",
    });
  } finally {
    loadingOverlay.stopLoading();
  }
};

onMounted(loadVideos);

// Computed para aplicar filtros e busca
const filteredVideos = computed(() => {
  let result = videos.value;

  if (search.value) {
    const s = search.value.toLowerCase();
    result = result.filter(
      (v) =>
        v.title.toLowerCase().includes(s) ||
        (v.description && v.description.toLowerCase().includes(s))
    );
  }

  if (filterType.value) {
    result = result.filter((v) => v.type === filterType.value);
  }

  return result;
});

// Paginação
const totalPages = computed(() =>
  Math.ceil(filteredVideos.value.length / perPage)
);

const paginatedVideos = computed(() => {
  const start = (page.value - 1) * perPage;
  return filteredVideos.value.slice(start, start + perPage);
});
</script>
